import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { FontIcon } from 'material-ui';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import { checkLocAccess } from '../../../middleware/accessCheckHelperFns';

const EditButton = ({ onEdit, editLabel, onDelete, deleteButton, readOnly, onClick }) => readOnly ? (
  <div className="edit-button" style={{ color: '#9e9e9e' }}>
    READ ONLY
  </div>
) : (
  <div className="edit-button">
    <span onClick={onEdit || onClick} className="flex-tc-sb">
      <FontIcon className="tc-icon-mode_edit" style={{ fontSize: '14px', color: '#00bcd4' }} /> {editLabel || 'Edit'}
    </span>
    {deleteButton ? (
      <span onClick={e => {
        e.stopPropagation();
        onDelete();
      }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '64px' }}>
        <DeleteIcon style={{ fontSize: '18px', color: '#00bcd4', margin: '0 0 1px 8px' }}/>Delete
      </span>
    ) : <span/>}
  </div>
);

EditButton.propTypes = {
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  deleteButton: PropTypes.bool,
  readOnly: PropTypes.bool,
  editLabel: PropTypes.string,
};
const mapStateToProps = state => {
  const { user, contracting } = state;
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  const readOnly = !checkLocAccess(state, leftNav.locationId, 'contracting', 'write');
  return { readOnly };
};

export default connect(mapStateToProps)(EditButton);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/edit-button.jsx